import { Observable } from 'rxjs/Observable'

import { Area } from '../../models'
import { AreaApi } from '../../apis'
import { Store } from '@ngrx/store'
import { AppState } from '../../reducers'
import { All } from '../../actions/area'

export abstract class AreaService {
  protected abstract LoadAreas(resourceId: number, areas: Area[]): All
  protected abstract AddArea(area: Area): All
  protected abstract RemoveArea(eventId: number): All

  constructor(
    protected api: AreaApi,
    protected store: Store<AppState>,
  ) { }

  index(videoId: number): Observable<Area[]> {
    return this.api.index(videoId)
  }

  all(videoId: number, groupIds?: number[]): Observable<Area[]> {
    return this.api.all(videoId, groupIds)
      .do((areas: Area[]) => this.store.dispatch(this.LoadAreas(videoId, areas)))
  }

  group(videoId: number): Observable<Area[]> {
    return this.api.group(videoId)
      .do((areas: Area[]) => this.store.dispatch(this.LoadAreas(videoId, areas)))
  }

  post(videoId: number, origin_x: number, origin_y: number, width: number, height: number): Observable<Area> {
    return this.api.post(videoId, origin_x, origin_y, width, height)
  }

  directPost(videoId: number, payload: any): Observable<Area> {
    return this.api.directPost(videoId, payload)
      .do(area => this.store.dispatch(this.AddArea(area)))
  }

  delete(videoId: number, eventId: number): Observable<any> {
    return this.api.delete(videoId, eventId)
      .do(() => this.store.dispatch(this.RemoveArea(eventId)))
  }
}




// WEBPACK FOOTER //
// ./src/services/area/base.ts